import { render, staticRenderFns } from "./Modal_Jumbo.vue?vue&type=template&id=0559d530&"
import script from "./Modal_Jumbo.vue?vue&type=script&lang=js&"
export * from "./Modal_Jumbo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports